module.exports = __webpack_public_path__ + "img/logo-copec-flux.7ff7d663.png";